import { render, staticRenderFns } from "./BookMark.vue?vue&type=template&id=8b5ff2c2&"
import script from "./BookMark.vue?vue&type=script&lang=js&"
export * from "./BookMark.vue?vue&type=script&lang=js&"
import style0 from "./BookMark.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports